import React from 'react';

var ListContext = /*#__PURE__*/React.createContext({});

export { ListContext };
